import { Prop } from '.'

export const huyImg =
  'https://lh3.googleusercontent.com/ogw/AF2bZygJspbfP8asP2yMS6yTSsftilmNfZI9TqpCB5MP=s32-c-mo'

export const DataEmploye: Prop[] = [
  {
    avatar: huyImg,
    name: 'Ryan Thompson',
    gmail: 'ryanthom@gmail.com',
    vacation: '15',
    sicklove: '3',
    workRemote: '50',
  },
  {
    avatar: huyImg,
    name: 'Ryan Thompson',
    gmail: 'ryanthom@gmail.com',
    vacation: '15',
    sicklove: '3',
    workRemote: '50',
  },
  {
    avatar: huyImg,
    name: 'Ryan Thompson',
    gmail: 'ryanthom@gmail.com',
    vacation: '15',
    sicklove: '3',
    workRemote: '50',
  },
  {
    avatar: huyImg,
    name: 'Ryan Thompson',
    gmail: 'ryanthom@gmail.com',
    vacation: '15',
    sicklove: '3',
    workRemote: '50',
  },

  {
    avatar: huyImg,
    name: 'Ryan Thompson',
    gmail: 'ryanthom@gmail.com',
    vacation: '15',
    sicklove: '3',
    workRemote: '50',
  },

  {
    avatar: huyImg,
    name: 'Ryan Thompson',
    gmail: 'ryanthom@gmail.com',
    vacation: '15',
    sicklove: '3',
    workRemote: '50',
  },
  {
    avatar: huyImg,
    name: 'Ryan Thompson',
    gmail: 'ryanthom@gmail.com',
    vacation: '15',
    sicklove: '3',
    workRemote: '50',
  },
  {
    avatar: huyImg,
    name: 'Ryan Thompson',
    gmail: 'ryanthom@gmail.com',
    vacation: '15',
    sicklove: '3',
    workRemote: '50',
  },
]
